
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/video-section",
      function () {
        return require("private-next-pages/video-section/index.page.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/video-section"])
      });
    }
  